import { gql } from '@apollo/client';

export type ReviewedCount = {
  count: number;
  reviewed: number;
};

const ReviewedCountFragment = gql`
  {
    count
    reviewed
  }
`;

export default ReviewedCountFragment;
